$(document).ready(function() {
    var product_details_contact_form = $('form[name=product_details_contact_form]');

    product_details_contact_form.validate({
        ignore: '.ignore',
        rules: {
            first_name: {
                required: true,
            },
            last_name: {
                required: true,
            },
            contact_number: {
                required: true,
            },
            email: {
                required: true,
                email: true,
            },
            message: {
                required: true,
            },
            product_details_contact_consent:{
                required: true,
            },
        },
        errorPlacement: function (error, element) {
            if(element.is("#product_details_contact_consent")) {
                swal('','Please tick consent box.','error');
            }
            $('.form').find('.loading').remove();
        },
        submitHandler: function () {
            product_details_contact_form.append('<img class="loading" src="' + $(document.body).data('base') + '/images/site/loading.gif">');

            $.ajax({
                type: "POST",
                url: $(document.body).data('base') + "/ajax/product-detail-contact-form.php",
                data: product_details_contact_form.serialize(),
                success: function (response) {
                    console.log(response);
                    var $response = JSON.parse(response);
                    product_details_contact_form.find('.loading').remove();

                    if (typeof $response === 'object' && $response !== null && $response.status !== 'success') {
                        swal({
                            title: '', 
                            text: $response.message, 
                            type: $response.status,
                            confirmButtonColor: "#f15a24"
                        });
                    } else {
                        product_details_contact_form.resetForm();
                        $('#contact-us-popup').hide();
                        $('.reveal-overlay').hide();
                        $('.is-reveal-open').css('overflow', 'visible');
                         swal({
                            title: 'Thank you!', 
                            text: $response.message, 
                            type: $response.status,
                            confirmButtonColor: "#f15a24"
                        });
                        ga('send', 'pageview', '/product-detail-contact-us-submit');
                        gtag("event", "product_detail_contact_us_submit");
                    }
                },
                error: function () {
                    console.log('Ajax request not received');
                }
            });

            return false;
        }
    });
});



$(document).ready(function() {
    var product_detail_quote_form = $('form[name=product_detail_quote_form]');

    product_detail_quote_form.validate({
        ignore: '.ignore',
        rules: {
            first_name: {
                required: true,
            },
            last_name: {
                required: true,
            },
            contact_number: {
                required: true,
            },
            email: {
                required: true,
                email: true,
            },
            message: {
                required: true,
            },
            product_detail_quote_consent:{
                required: true,
                     
            },
        },
        errorPlacement: function (error, element) {
            if(element.is("#product_detail_quote_consent")) {
                swal('','Please tick consent box.','error');
            }
            $('.form').find('.loading').remove();
        },
        submitHandler: function () {
            product_detail_quote_form.append('<img class="loading" src="' + $(document.body).data('base') + '/images/site/loading.gif">');

            $.ajax({
                type: "POST",
                url: $(document.body).data('base') + "/ajax/product-detail-quote-form.php",
                data: product_detail_quote_form.serialize(),
                success: function (response) {
                    console.log(response);
                    var $response = JSON.parse(response);
                    product_detail_quote_form.find('.loading').remove();

                    if (typeof $response === 'object' && $response !== null && $response.status !== 'success') {
                        swal({
                            title: '', 
                            text: $response.message, 
                            type: $response.status,
                            confirmButtonColor: "#f15a24"
                        });
                    } else {
                        product_detail_quote_form.resetForm();
                        $('#get-a-quote-popup').hide();
                        $('.reveal-overlay').hide();
                        $('.is-reveal-open').css('overflow', 'visible');
                         swal({
                            title: 'Thank you!', 
                            text: $response.message, 
                            type: $response.status,
                            confirmButtonColor: "#f15a24"
                        });


                        ga('send', 'pageview', '/product-detail-quote-submit');
                        gtag("event", "product_detail_quote_submit");
                    }
                },
                error: function () {
                    console.log('Ajax request not received');
                }
            });

            return false;
        }
    });
});